// External Dependencies:
import React from 'react'
import { browserHistory } from 'react-router'
import { Link } from 'react-router-dom'
import DocumentMeta from 'react-document-meta'
import lozad from 'lozad'

// Internal Dependencies:
import SafePaw from 'components/svg/safe-paw'
import SafeMap from 'components/svg/map-blue'
// import Sponsors from 'components/sponsors/sponsors'

class HomeContent extends React.Component {
	constructor() {
		super()

		this.observer = lozad( '.lozad', {
			load: ( el ) => {
				el.src = el.dataset.src
				el.onload = () => {
					el.classList.add( 'lozad-loaded' )
				}
			}
		})
	}

	componentDidMount() {
		this.observer.observe()
	}

	render() {
		const meta = {
			title: safeSiteData.site_name,
			description: safeSiteData.site_description,
			canonical: safeSiteData.site_url,
			meta: {
				'og:url': safeSiteData.site_url,
				'og:title': safeSiteData.site_name,
				'og:description': safeSiteData.site_description,
				'og:image': ''
			}
		}

		let min = 1,
			max = safeSiteData.home_featured_images.length
		const imageVersion = safeSiteData.home_version ? safeSiteData.home_version : Math.floor( Math.random() * ( max - min + 1 ) + min )
		const imageUrl = safeSiteData.home_featured_images[ imageVersion - 1 ]

		return (
			<div>
				<DocumentMeta { ...meta } />

				<div className={ 'main-hero main-hero-v-' + imageVersion }>
					<div className="-bg">
						<div className="-bg-inner" style={ { backgroundImage: `url( ${ imageUrl } )` } }></div>
					</div>
				</div>

				<div className="wide-sections">
					<div className="wide-section">
						<div className="main-title">
							<h1 dangerouslySetInnerHTML={ { __html: safeSiteData.home_subtitle } } />

							<p>
								{ safeSiteData.home_intro }
							</p>
						</div>
					</div>

					<div className="wide-section -special-feature">
						<div className="-inner">
							<div className="-image">
								<div className="-inner">
									<a href="https://www.safewa.org.au/product-page/nellie-to-the-rescue" target="_blank" rel="noopener">
										<img className="lozad" data-src={ safeSiteData.images_url + 'shop/Nellie-to-the-rescue-b.jpg' } alt="" />
									</a>
								</div>
							</div>

							<div className="-text">
								<h3>Nellie to the Rescue</h3>

								<p>The story of Nellie has been designed to help children accept inevitable life changes, and to witness, through Nellie the rescue pup, how well she managed the changes that life presented to her. It also highlights the vital role that animals play in our lives and shows, in the end, how Nellie was not the only one rescued.</p>

								<p>
									<a href="https://www.safewa.org.au/product-page/nellie-to-the-rescue" className="button" target="_blank" rel="noopener">Shop here</a>
								</p>
							</div>
						</div>
					</div>

					<div className="wide-section -features">
						<div className="-inner">
							<div className="-features-grid">
								<div className="-feature">
									<Link className="-feature-inner" to="/help-us-out/">
										<div className="-image">
											<img className="lozad" data-src={ safeSiteData.images_url + 'animals/help-us-out-b.jpg' } alt="" style={ { objectPosition: 'top center' } } />
										</div>

										<div className="-text">
											<h3>Help us out</h3>
										</div>
									</Link>
								</div>

								<div className="-feature">
									<Link className="-feature-inner" to="/find-a-dog">
										<div className="-image">
											<img className="lozad" data-src={ safeSiteData.images_url + 'animals/find-a-dog-b.jpg' } alt="" />
										</div>

										<div className="-text">
											<h3>Find a dog</h3>
										</div>
									</Link>
								</div>

								<div className="-feature">
									<Link className="-feature-inner" to="/find-a-cat">
										<div className="-image">
											<img className="lozad" data-src={ safeSiteData.images_url + 'animals/find-a-cat-b.jpg' } alt="" style={ { objectPosition: 'top center' } } />
										</div>

										<div className="-text">
											<h3>Find a cat</h3>
										</div>
									</Link>
								</div>
							</div>
						</div>
					</div>

					<div className="-main-line -main-line-2"></div>

					<div className="wide-section -double">
						<div className="-inner">
							<div className="-a">
								<div className="-heading">
									<h2 className="with-dash" dangerouslySetInnerHTML={ { __html: safeSiteData.home_1_l_h } }></h2>
								</div>

								<div className="-text" dangerouslySetInnerHTML={ { __html: safeSiteData.home_1_l_t } }></div>
							</div>

							<div className="-b">
								<h3 dangerouslySetInnerHTML={ { __html: safeSiteData.home_1_r_h } } />

								<div dangerouslySetInnerHTML={ { __html: safeSiteData.home_1_r_text } } />
							</div>
						</div>
					</div>

					<div className="wide-section-map wide-section">
						<div className="-main-line -main-line-full"></div>

						<div className="-inner">
							<div className="-map">
								<div className="-map-inner">
									<SafeMap />

									<Link className="-location -avon-valley" to="/safe-avon-valley">
										<div className="-city">Avon Valley</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -broome" to="/safe-broome">
										<div className="-city">Broome</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -bunbury" to="/safe-bunbury">
										<div className="-city">Bunbury</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -busselton" to="/safe-busselton">
										<div className="-city">Busselton</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -carnavon" to="/safe-carnarvon">
										<div className="-city">Carnarvon</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -esperance" to="/safe-esperance">
										<div className="-city">Esperance</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -goldfields" to="/safe-goldfields">
										<div className="-city">Goldfields</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -hedland" to="/safe-hedland">
										<div className="-city">Hedland</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -karratha" to="/safe-karratha">
										<div className="-city">Karratha and SAFE HQ</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -metro" to="/safe-metro-perth">
										<div className="-city">Metro (Perth)</div>
										<div className="-marker"></div>
									</Link>

									<Link className="-location -newman" to="/safe-newman">
										<div className="-city">Newman</div>
										<div className="-marker"></div>
									</Link>
								</div>
							</div>

							<div className="-text">
								<h2 className="with-dash">Our Branches</h2>

								<div className="-locations">
									<section>
										<ul>
											<li><Link to="/safe-avon-valley">Avon Valley</Link></li>
											<li><Link to="/safe-broome">Broome</Link></li>
											<li><Link to="/safe-bunbury">Bunbury</Link></li>
											<li><Link to="/safe-busselton">Busselton</Link></li>
											<li><Link to="/safe-carnarvon">Carnarvon</Link></li>
										</ul>
									</section>

									<section>
										<ul>
											<li><Link to="/safe-esperance">Esperance</Link></li>
											<li><Link to="/safe-goldfields">Goldfields</Link></li>
											<li><Link to="/safe-hedland">Hedland</Link></li>
											<li><Link to="/safe-karratha">Karratha</Link></li>
											<li><Link to="/safe-metro-perth">Metro (Perth)</Link></li>
											<li><Link to="/safe-newman">Newman</Link></li>
										</ul>
									</section>
								</div>
							</div>
						</div>
					</div>

					<div className="wide-section -double">
						<div className="-inner">
							<div className="-a">
								<div className="-heading">
									<h2 className="with-dash">More about us</h2>
								</div>

								<div className="-text">
									<p>Hey there! Pull up a chair with your favourite beverage in hand, and let me tell you all about SAFE (Saving Animals from Euthanasia). You might be wondering, "What is SAFE all about?" Well, let me give you the inside scoop.</p>

									<p>Imagine a group of passionate individuals spread across Western Australia, all working tirelessly to make a difference in the lives of our best friends. Well, that's SAFE Inc in a nutshell. We're not just your average animal rescue organisation – we are families united by a common goal: to provide SAFE havens for cats and dogs until they find their adoptive homes.</p>

									<p>So, what exactly do we do? Well, let me break it down for you. At SAFE, we specialise in fostering cats and dogs who have found themselves without a home. These animals come to us from various situations – some are strays, some have been surrendered by their owners, and others have been rescued from dire circumstances. But regardless of their past, we welcome each and every one of them with open arms.</p>

									<p>Our network of dedicated volunteers across our 11 branches ensures that these animals receive the love, care, and attention they deserve. From providing medical treatment to offering behavioural support, our volunteers go above and beyond to ensure that every animal in our care is happy and healthy.</p>

									<p>Our dedication doesn't end there. We're also devoted to securing a new adoptive family for every one of our furry companions. Utilising our thorough adoption process, we meticulously pair pets into caring homes who will cherish them deeply. Witnessing a once-homeless animal being embraced and adored in their foster home is incredibly fulfilling. Our foster caregivers treat these animals as their own until their adoptive family comes along. At SAFE, we operate solely as a foster care organisation, we do not have a shelter, and avoid using cages unless necessary for short term care, in favour of a more nurturing environment for our animals.</p>

									<p>At SAFE, we believe in the power of community. That's why we collaborate with local rangers, veterinary clinics, and animal advocates to make a greater impact. Together, we're not just saving lives – we're changing them for the better.</p>
								</div>
							</div>

							<div className="-b">
								<h3>So, why should you choose to foster, adopt, volunteer, or donate to SAFE?</h3>

								<p>Well, besides the warm fuzzies you'll get from knowing you're making a difference, there are a few other reasons. Firstly, transparency is at the core of everything we do. We believe in keeping our supporters informed through all types of media updates as well as reaching out to people in our local communities.</p>

								<p>Secondly, accountability is key. We hold ourselves to the highest standards of animal welfare, ensuring that all our practices adhere to ethical guidelines. From the moment an animal enters our care to the day they find their adoptive home, we prioritise their well-being even being available to rehome again if this is required.</p>

								<p>And finally, passion drives us forward. Each and every member of the SAFE Inc team is driven by a deep love for animals and a desire to make the world a better place for them. It's this passion that fuels our efforts and keeps us going, even in the face of ongoing challenges.</p>

								<p>So, there you have it – SAFE in a nutshell. From our 11 branches to our commitment to animal welfare, we're here to make a difference, one furry friend at a time.</p>

								<p>Thanks for joining us on this journey – together, we can create a brighter future for all creatures great and small. Cheers!</p>

								<img className="lozad" data-src={ safeSiteData.images_url + 'home/park.jpg' } alt="" />
							</div>
						</div>
					</div>

					<div className="splash main-2">
						<div className="-inner">
							<div className="-main">
								<img className="lozad" data-src={ safeSiteData.images_url + 'people/sue-hedley-b.jpg' } alt="" />

								<div className="-text">
									<p dangerouslySetInnerHTML={ { __html: safeSiteData.home_2_t } } />

									<p>
										<Link to={ safeSiteData.home_2_l_url } className="button">{ safeSiteData.home_2_l_t }</Link>
									</p>
								</div>
							</div>
						</div>
					</div>

				</div>

				<div className="wide-section-sponsors wide-section-acnc wide-section">
					<div className="-inner">
						<div className="-sponsors">
							<a className="-sponsor" href="https://www.acnc.gov.au/charity/81a06c96244392ad2c03525dde9d517c" target="_blank" rel="noopener">
								<img className="lozad" data-src={ safeSiteData.images_url + 'sponsors/acnc.jpg' } alt="ACNC" />
							</a>
						</div>
					</div>
				</div>

				{/*<Sponsors network={ true } />*/}

				<div className="wide-section-sponsors wide-section-awla wide-section">
					<div className="-inner">
						<h3>Proud Member of Companion Animal Network – Australia CAN</h3>

						<div className="-sponsors">
							<a className="-sponsor" href="https://australiacan.org.au/" target="_blank" rel="noopener">
								<img className="lozad" data-src={ safeSiteData.images_url + 'sponsors/can.png' } alt="Companion Animal Network – Australia CAN" />
							</a>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default HomeContent



// WEBPACK FOOTER //
// ./views/main/home/home-content.jsx